const dialog = document.querySelector('dialog[data-expand-range-dialog]');
const closeButton = dialog?.querySelector('[data-close-dialog]');
const showButton = dialog?.previousElementSibling;
const productList = dialog?.querySelector('ul[data-product-list]');
const url = dialog?.dataset?.url;

/**
 * Fetch complimentary products from Shopify
 * @param {string} url - URL to fetch products from
 * @returns {Promise}
 */
const fetchProducts = async (url) => {
  const response = await fetch(window.Shopify.routes.root + url);
  const { products } = await response.json();

  return products;
};

const buildset = (src) => {
  const sizes = [120, 240, 360];
  const srcSet = sizes.map((size) => `${src}?width=${size} ${size}w`);

  return srcSet.join(', ');
};

const sanitiseSrc = (src) => src.split('?')[0];

const findCutout = (media) => {
  const cutout = media.find((item) => item.alt === 'cut-out');

  return cutout ? cutout.src : media[0].src;
};

const formatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/**
 * Render products in the modal
 * @param {Array} products - Array of products to render
 */
const renderProducts = (products) => {
  if (!products.length) {
    return;
  }

  const addToCartText = window.matchMedia('(max-width: 768px)').matches
    ? 'Add'
    : 'Add to cart';

  productList.innerHTML = '';

  for (const product of products) {
    const listItem = document.createElement('li');
    const src = findCutout(product.media);
    const newSrc = sanitiseSrc(src);

    listItem.classList.add('expand-range__item');
    listItem.innerHTML = `
    <product-form data-product-form data-product-id="${product.id}">
      <form
        method="post" 
        action="/cart/add" 
        id="product-form-${product.id}" 
        accept-charset="UTF-8" 
        class="expand-range__form"
        enctype="multipart/form-data"
        novalidate="novalidate"
        data-type="add-to-cart-form"
        >
          <input type="hidden" name="form_type" value="product">
          <input type="hidden" name="utf8" value="✓">
          <input type="hidden" name="id" value="${product.variants[0].id}">
          <a href="${product.url}" class="expand-range__link">
            <img
              srcset="${buildset(newSrc)}"
              sizes="(max-width: 767px) 80px, 120px"
              src="${newSrc}?width=240"
              alt="${product.title}"
            >
          </a>
          <div class="expand-range__meta">
            <h3 class="expand-range__meta-title">${product.title}</h3>
            <p>${formatter.format(product.price / 100)}</p>
            <a href="${
              product.url
            }" class="link link--small link--text link--bold">View product</a>
          </div>
          <button
            data-add-to-cart
            type="submit"
            id="${product.variants[0].id}"
            class="expand-range__cart button button--accent"
            >
              ${addToCartText}
          </button>
        </form>
    </product-form>
    `;

    productList.appendChild(listItem);
  }
};

const animationEnded = () => {
  dialog?.classList.remove('hide');
  dialog?.close();
  dialog?.removeEventListener('animationend', animationEnded);
};

// "Show the dialog" button opens the dialog modally
showButton.addEventListener('click', async () => {
  dialog.showModal();
  const products = await fetchProducts(url);
  renderProducts(products);
});

// "Close" button closes the dialog
closeButton.addEventListener('click', () => {
  dialog?.classList.add('hide');
  dialog?.addEventListener('animationend', animationEnded);
});
